import type { TimelineMeta } from '../types/agreementTimeline.types';

// Page numbers are 1-based: shared `Pagination` computes (currentPage - 1) * perPage + 1,
// so a 0 from the API would render a negative range. Only `total` may legitimately be 0.
const asInt = (value: unknown, min: number, fallback: number): number => {
    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed >= min ? parsed : fallback;
};

export const readTimelineMeta = (
    meta: Record<string, unknown>,
    params: { page: number; perPage: number },
): TimelineMeta => ({
    currentPage: asInt(meta.current_page, 1, params.page),
    lastPage: asInt(meta.last_page, 1, 1),
    perPage: asInt(meta.per_page, 1, params.perPage),
    total: asInt(meta.total, 0, 0),
});
